"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiListUsersResponse = instanceOfApiListUsersResponse;
exports.ApiListUsersResponseFromJSON = ApiListUsersResponseFromJSON;
exports.ApiListUsersResponseFromJSONTyped = ApiListUsersResponseFromJSONTyped;
exports.ApiListUsersResponseToJSON = ApiListUsersResponseToJSON;
exports.ApiListUsersResponseToJSONTyped = ApiListUsersResponseToJSONTyped;
const ApiGetUserResponse_1 = require("./ApiGetUserResponse");
/**
 * Check if a given object implements the ApiListUsersResponse interface.
 */
function instanceOfApiListUsersResponse(value) {
    if (!('users' in value) || value['users'] === undefined)
        return false;
    if (!('total' in value) || value['total'] === undefined)
        return false;
    return true;
}
function ApiListUsersResponseFromJSON(json) {
    return ApiListUsersResponseFromJSONTyped(json, false);
}
function ApiListUsersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'users': (json['users'].map(ApiGetUserResponse_1.ApiGetUserResponseFromJSON)),
        'total': json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
    };
}
function ApiListUsersResponseToJSON(json) {
    return ApiListUsersResponseToJSONTyped(json, false);
}
function ApiListUsersResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'users': (value['users'].map(ApiGetUserResponse_1.ApiGetUserResponseToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
    };
}
